import {
  SandpackProvider,
  SandpackLayout,
  SandpackCodeEditor,
  SandpackFiles,
  SandpackProviderProps,
  useSandpack,
} from "@codesandbox/sandpack-react";
import { useMemo } from "react";
import SandpackPreviewWithConsole from "./SandpackPreviewWithConsole";
import { PanelGroup, Panel, PanelResizeHandle } from "react-resizable-panels";
import TestResultSummary from "./TestResultSummary";
import { ITestStatus } from "./statics";
import { Broom, Check, CloudArrowUp, Play } from "@phosphor-icons/react";

function SaveButton({
  disabled,
  showSuccess,
  onSave,
}: {
  disabled: boolean;
  showSuccess: boolean;
  onSave: (files: SandpackFiles) => void;
}) {
  const { sandpack } = useSandpack();
  return (
    <button
      className="bg-white/5 pl-3 pr-4 rounded-lg hover:text-white transition-all cursor-pointer flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
      onClick={() => onSave(sandpack.files as SandpackFiles)}
      disabled={disabled}
    >
      {showSuccess ? (
        <>
          <Check size={16} className="text-myGreen" />
          Yüklendi
        </>
      ) : (
        <>
          <CloudArrowUp size={16} className="text-white/50" />
          Kaydet
        </>
      )}
    </button>
  );
}

function SandpackWithEditor({
  files,
  setFiles,
  spOptionz,
  testResults,
  handleReset,
  handleSave,
  showSuccess,
}: {
  files: SandpackFiles;
  setFiles: (s: SandpackFiles) => void;
  spOptionz: SandpackProviderProps;
  testResults: ITestStatus;
  handleReset: () => void;
  handleSave: (currentFiles: SandpackFiles) => void;
  showSuccess: boolean;
}) {
  const memoEditor = useMemo(() => {
    return (
      <SandpackProvider {...spOptionz} files={files} className="!h-full">
        <SandpackLayout className="!h-full">
          <PanelGroup direction="horizontal" id="editorAndConsole" className="">
            <Panel minSize={30} defaultSize={70}>
              <div className="flex flex-col h-full">
                <div className="p-2 pr-1 bg-surface-1">
                  <div className="spm-title flex items-stretch gap-1 !px-1 !py-1">
                    <span className="flex-1 py-2 pl-3 self-center">EDİTÖR</span>
                    <button
                      className="bg-white/5 pl-3 pr-4 rounded-lg hover:text-myRose transition-all cursor-pointer flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                      disabled={testResults.status === "RUNNING"}
                      onClick={handleReset}
                    >
                      <Broom size={16} className="text-myRose" />
                      <span>Sıfırla</span>
                    </button>
                    <SaveButton
                      disabled={testResults.status === "RUNNING"}
                      showSuccess={showSuccess}
                      onSave={handleSave}
                    />
                    <button
                      className="bg-white/5 pl-2 pr-4 rounded-lg hover:text-myGreen transition-all cursor-pointer flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                      id="myRunButton"
                      disabled={testResults.status === "RUNNING"}
                    >
                      <Play size={14} className="text-myGreen" weight="fill" />
                      Çalıştır
                    </button>
                  </div>
                </div>

                <div className="flex-1 overflow-hidden">
                  <SandpackCodeEditor
                    className="h-full"
                    wrapContent
                    showTabs={true}
                    showLineNumbers={true}
                  />
                </div>
              </div>
            </Panel>
            <div className="p-1 pt-2 group bg-surface-2 relative">
              <PanelResizeHandle className="w-0.5 h-full resizer" />
              <div className="resizer-ind h-7 w-2 left-[1px] top-1/2 -translate-y-1/2" />
            </div>
            <Panel>
              <PanelGroup direction="vertical" className="">
                <Panel defaultSize={50}>
                  <TestResultSummary data={testResults.results} />
                </Panel>
                <div className="p-1 pr-2 group bg-surface-2 relative">
                  <PanelResizeHandle className="h-0.5 w-full resizer" />
                  <div className="resizer-ind w-7 h-2 top-[1px] left-1/2 -translate-x-1/2" />
                </div>
                <Panel className="p-1 pr-2 bg-surface-1">
                  <div className="flex flex-col h-full">
                    <div className="spm-title">CONSOLE</div>
                    <div className="flex-1 overflow-auto">
                      <SandpackPreviewWithConsole setFiles={setFiles} />
                    </div>
                  </div>
                </Panel>
              </PanelGroup>
            </Panel>
          </PanelGroup>
        </SandpackLayout>
      </SandpackProvider>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setFiles, testResults, showSuccess, handleSave, handleReset]);

  return memoEditor;
}
export default SandpackWithEditor;
